import { IEventSchema } from '@faire/web-api--source/indigofair/data/IEventSchema';
import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'retailer_marketing-trustpilot_testimonials-view';

/**
 * User views trustpilot widget in the testimonials carousel
 */
export function trackRetailerMarketingTrustpilotTestimonialsView(): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    priority: IEventSchema.Priority.EXTRA_LOW,
  });
}
